/**
 * Pagination de la liste des dossiers.
 *
 * Module pur : aucune dependance, aucun acces reseau. La base plafonne de son
 * cote la taille de page a 100 (migration 0006) — ce qui est ici n'est qu'un
 * confort d'affichage, jamais une barriere.
 */

/** 25 lignes par page. */
export const TAILLE_PAGE = 25

/** Decalage SQL d'une page, numerotee a partir de 1. */
export function decalage(page: number, taille: number = TAILLE_PAGE): number {
  const pageSure = Math.max(1, Math.floor(page))
  return (pageSure - 1) * taille
}

/**
 * Nombre de pages.
 *
 * Zero resultat donne UNE page, pas zero : « page 1 sur 0 » n'a pas de sens a
 * l'ecran, et une liste vide reste une page qu'on affiche.
 */
export function nombrePages(total: number, taille: number = TAILLE_PAGE): number {
  if (total <= 0) return 1
  return Math.ceil(total / taille)
}

/** Ramene une page demandee dans les bornes existantes. */
export function pageDansLesBornes(
  page: number,
  total: number,
  taille: number = TAILLE_PAGE,
): number {
  const dernier = nombrePages(total, taille)
  if (!Number.isFinite(page)) return 1
  return Math.min(Math.max(1, Math.floor(page)), dernier)
}

export interface Intervalle {
  /** Rang du premier element affiche, a partir de 1. Zero si la page est vide. */
  readonly premier: number
  /** Rang du dernier element affiche. Zero si la page est vide. */
  readonly dernier: number
  readonly total: number
}

/**
 * Intervalle affiche, pour « 26 a 50 sur 137 ».
 *
 * Une page vide rend 0 a 0 : on ne fabrique pas un intervalle plausible pour
 * une page qui ne contient rien.
 */
export function intervalleAffiche(
  page: number,
  total: number,
  taille: number = TAILLE_PAGE,
): Intervalle {
  if (total <= 0) return { premier: 0, dernier: 0, total: 0 }

  const pageSure = pageDansLesBornes(page, total, taille)
  const premier = decalage(pageSure, taille) + 1

  if (premier > total) return { premier: 0, dernier: 0, total }

  return { premier, dernier: Math.min(premier + taille - 1, total), total }
}
